import { CommonModule } from '@angular/common';
import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit, HostListener } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { Router, RouterLink } from '@angular/router';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { HttpService } from '../../services/http.service';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { UserAccountDTO } from '../../classes/user-account.dto';
import { StorageService } from '../../services/storage.service';
import { AVAILABLE_CARDS } from '../../mocks/mock-data';

interface Card {
  icon: string;
  title: string;
  description: string;
  buttonRoute: string;
  type: string;
  buttonText: string;
  service: string;
}

@Component({
  selector: 'app-card-list',
  standalone: true,
  imports: [NzCardModule, NzIconModule, NzCarouselModule, TranslateModule, CommonModule, RouterLink, NzDividerModule],
  templateUrl: './card-list.component.html',
  styleUrl: './card-list.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardListComponent implements OnInit {
  @Input() healthBookings!: Card[];
  notification: any;
  availableCards: Card[] = [];
  currentPage = 0;
  cardsPerPage = 1;
  notificationMap: { [key: string]: any } = {};
  isUserManagementAble: boolean = false;
  isPreviewMode: boolean = false;

  constructor(
    private router: Router,
    private http: HttpService,
    private storage: StorageService
  ) {}

  ngOnInit() {
    this.isPreviewMode = this.router.url.startsWith('/preview-page');
    this.filterCardsByUserFunctions();
    if(!this.isPreviewMode){
      this.loadNotifications();
      this.calculateCardsPerPage();
      const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
      this.isUserManagementAble = userData.functions ? userData.functions.includes('MPM') : false;
      window.addEventListener('resize', () => {
        this.calculateCardsPerPage();
      });
    }
  }

  private filterCardsByUserFunctions(): void {
    const userData = JSON.parse(localStorage.getItem('userData')!);
    const userFunctions: string[] = userData?.functions || [];
    if(!this.isPreviewMode){
      this.availableCards = this.healthBookings.filter((card) => userFunctions.includes(card.type));
    } else{
      this.availableCards = AVAILABLE_CARDS;
    }
  }

  private loadNotifications(): void {
    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    const individualId = userData?.individualId;

    this.availableCards.forEach((card) => {
      if (card.service != "") {
        this.http.getNotificationCard(card.service, individualId).subscribe((res: any) => {
          if (Array.isArray(res) && res.length > 0) {
            let notification;
            if (card.type === 'MCS') {
              notification = res.find((r: any) => r.name === 'SPECIALIST');
            } else {
              notification = res.find((r: any) => r.name === 'GENERIC');
            }
            this.notificationMap[card.service] = notification ?? res[0];
          } else {
            this.notificationMap[card.service] = null;
          }
        });
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.calculateCardsPerPage();
    }, 0);
  }

  @HostListener('window:resize', [])
  onResize() {
    this.calculateCardsPerPage();
  }

  calculateCardsPerPage(): void {
    const container = document.querySelector('.cardList');
    if (!container) return;

    const containerWidth = container.clientWidth;
    const cardWidth = 220;
    this.cardsPerPage = Math.max(1, Math.floor(containerWidth / cardWidth));

    if (this.currentPage >= this.totalPages) {
      this.currentPage = Math.max(0, this.totalPages - 1);
    }
  }

  get totalPages(): number {
    return Math.ceil(this.availableCards.length / this.cardsPerPage);
  }

  get paginatedCards(): Card[] {
    const start = this.currentPage * this.cardsPerPage;
    return this.availableCards.slice(start, start + this.cardsPerPage);
  }

  public nextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
    }
  }

  public prevPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }
  ngOnDestroy(): void {
    window.removeEventListener('resize', this.calculateCardsPerPage);
  }
}
